import { useEffect, useState } from 'react';
import { LAPUSHOK_URL } from '@/config.ts';

export function AdminPanel() {
  const [serversStats, setServersStats] = useState({});

  useEffect(() => {
    fetch(`${LAPUSHOK_URL}/servers/stats`)
      .then(res => res.json())
      .then(setServersStats);
  }, []);

  return (
    <div className="admin-panel">
      <h1>Server Notification Statistics</h1>
      {Object.entries(serversStats).map(([serverId, stats]) => (
        <div key={serverId} className="server-stats">
          <h3>Server: {serverId}</h3>
          <p>Total Subscribers: {stats.totalSubscribers}</p>
          {Object.entries(stats.channels).map(([channelId, count]) => (
            <p key={channelId}>#{channelId}: {count} subscribers</p>
          ))}
        </div>
      ))}
    </div>
  );
}